import { versaoTeste } from './Stores.js';

class consolar {
  // Métodos adicionais específicos para a classe AppDataLogin, se necessário
  static log(objeto, objeto2 = '') {
    let libera=false;
    versaoTeste.subscribe(value => {
      if (value == 1 ||libera) {
        if (objeto2) {
          console.log(objeto, objeto2);
        } else {
          console.log(objeto);
        }
      }
    })();
  }
}

export default consolar;
